import { render, staticRenderFns } from "./UserAddPassword.vue?vue&type=template&id=cf6671f0&"
import script from "./UserAddPassword.vue?vue&type=script&lang=js&"
export * from "./UserAddPassword.vue?vue&type=script&lang=js&"
import style0 from "./UserAddPassword.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports